import { EGalleryLabelColor, IGalleryLabel } from '../../types/gallery-label';
import { getOfferPromoLabels } from './labels/getOfferPromoLabels';
import { getOfferRankingLabels } from './labels/getOfferRankingLabels';
import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { getOfferSavedSearchLabels } from './labels/getOfferSavedSearchLabels';

export const mediaLabels: TComputedPropMapper<IGalleryLabel[]> = ({ offer, withAuction }) => {
  let labels: IGalleryLabel[] = [];

  if (!!offer.user && !!offer.user.bank && !withAuction) {
    labels.push({ label: 'Залоговая недвижимость', color: EGalleryLabelColor.LightGrey } as IGalleryLabel);
  }

  if (withAuction) {
    labels.push({ label: 'Залоговая недвижимость, аукцион', color: EGalleryLabelColor.LightGrey } as IGalleryLabel);
  }

  if (!!offer.savedSearchLabels) {
    labels = [...labels, ...getOfferSavedSearchLabels(offer.savedSearchLabels)];
  }

  if (!!offer.promoInfo) {
    labels = [...labels, ...getOfferPromoLabels(offer)];
  }

  if (!!offer.photoLabels) {
    labels = [...labels, ...getOfferRankingLabels(offer)];
  }

  return labels;
};
